export default __webpack_public_path__ + "static/media/B52_6.15864fb5.webp";